import { render } from "./Advantage-Disadvantage.vue?vue&type=template&id=7d08838e&ts=true"
import script from "./Advantage-Disadvantage.vue?vue&type=script&lang=ts"
export * from "./Advantage-Disadvantage.vue?vue&type=script&lang=ts"

import "./Advantage-Disadvantage.vue?vue&type=style&index=0&id=7d08838e&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__